import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_3 = {
  class: "dialog-footer"
};
import { Lock } from '@/entity/Lock';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';
import { useUserDataStore } from '@/store/userData';
// import { ElMessage } from 'element-plus'
import { sleep } from '@/utils/common';
import { router } from '@/router';
export default {
  __name: 'lockDetail',
  setup(__props) {
    const userData = useUserDataStore();
    userData.init();
    const route = useRoute();
    const data = reactive({
      lock: undefined,
      alertStep: 0,
      alertDiag: false,
      alertTxt: ""
    });
    data.lock = Lock.fromUrl(route.params.data);
    function shareAlert() {
      data.alertTxt = "警告！您正在执行一项非常危险的操作！\n分享您的门锁信息这一行为是不可逆的，门锁的保密数据理论上会伴随一个账号从创建到注销，一旦数据被获取，将会是安全数据的永久性泄露。\n您只应该于您非常非常信任的人或者您自己的其他设备线下共享该信息。\n确定要执行该操作吗？";
      data.alertDiag = true;
      data.alertStep = 0;
    }
    async function alertConfirm() {
      await sleep(500);
      data.alertStep++;
      if (data.alertStep == 1) {
        data.alertTxt = "警告！您正在执行一项的操作确实是非常危险的！\n您不应该为了图方便而将门锁通过互联网等途径共享给其他人，即便对方急需开门进入寝室\n您只应该于您非常非常信任的人或者您自己的其他设备线下共享该信息。\n再次确定，要执行该操作吗？";
        data.alertDiag = true;
      }
      if (data.alertStep == 2) {
        data.alertTxt = "确认操作后将在屏幕上显示门锁数据的二维码。如非必要，请不要截图保存或发送给他人。扫码时请关注身边，避免二维码被盗扫。您确定要分享数据吗";
        data.alertDiag = true;
      }
      if (data.alertStep == 3) {
        router.push("/lockQR/" + data.lock.toString(true));
      }
    }
    function setDef() {
      let tmp = Lock.fromUrl(data.lock.toString());
      tmp.label = "[默认]" + tmp.label;
      userData.defaultLock = tmp.toString();
      userData.save();
    }
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, null, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions, {
            title: "门锁信息",
            column: 1,
            border: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "LABEL"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.lock.label), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "S-UUID"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.lock.D_SERV), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "C-UUID"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.lock.D_CHAR), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "MAC"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.lock.D_MAC), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _hoisted_1, _hoisted_2, _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: shareAlert
        }, {
          default: _withCtx(() => [_createTextVNode("分享")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: setDef
        }, {
          default: _withCtx(() => [_createTextVNode("设为默认")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: data.alertDiag,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.alertDiag = $event),
        title: "警告",
        "align-center": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => data.alertDiag = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => {
            data.alertDiag = false;
            alertConfirm();
          })
        }, {
          default: _withCtx(() => [_createTextVNode(" 确定 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(data.alertTxt), 1)]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};